import { ContractHonorariumStatus } from '../../dto/contractHonorarium/ContractHonorariumDTO'
import { EDistributionContractType } from '../../enums/EDistributionContractType'
import { formatMoney } from '../../utils/money'

const percentageFormatter = new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const GENERAL_LABEL = 'General'

export function parseIsoDate(value: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)
  if (!match) return null
  const [, year, month, day] = match
  return new Date(Number(year), Number(month) - 1, Number(day))
}

export function formatIsoDate(value: string | null): string {
  if (!value) return ''
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)
  if (!match) return value
  const [, year, month, day] = match
  return `${day}/${month}/${year}`
}

export function formatIsoDateTime(value: string | null): string {
  if (!value) return '—'
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(value)
  if (!match) return value
  const [, year, month, day, hour, minute] = match
  return `${day}/${month}/${year} ${hour}:${minute}`
}

export function formatPercentage(value: number | null): string {
  return value == null ? '—' : `${percentageFormatter.format(value)} %`
}

export function isFixedAmount(distributionTypeId: number | null): boolean {
  return distributionTypeId === EDistributionContractType.FIXED_AMOUNT
}

export function describeValues(values: {
  distributionTypeId: number | null
  honoPercentage: number | null
  copaymentPercentage: number | null
  diferentialPercentage: number | null
  fixedAmount: number | null
}): string {
  if (isFixedAmount(values.distributionTypeId)) return formatMoney(values.fixedAmount)
  return [
    `${formatPercentage(values.honoPercentage)} hon.`,
    `${formatPercentage(values.copaymentPercentage)} cos.`,
    `${formatPercentage(values.diferentialPercentage)} dif.`,
  ].join(' · ')
}

export function nameOrGeneral(value: string | null): string {
  return value && value.trim() ? value : GENERAL_LABEL
}

export const STATUS_LABELS: Record<ContractHonorariumStatus, string> = {
  CURRENT: 'Vigente',
  FUTURE: 'Futura',
  EXPIRED: 'No vigente',
}

export const STATUS_TAG_CLASSES: Record<ContractHonorariumStatus, string> = {
  CURRENT: 'md-tag md-tag-ok',
  FUTURE: 'md-tag md-tag-warn',
  EXPIRED: 'md-tag md-tag-mut',
}

/**
 * Tipo del contrato según su emisor: con un profesional como emisor es de retención (lo que no se queda el
 * profesional se le retiene); con la institución, de distribución (se le paga su parte).
 */
export function contractKindLabel(billingEntityProfessional: boolean): string {
  return billingEntityProfessional ? 'Retención' : 'Distribución'
}

export const RETENTION_CONTRACT_HELP =
  'Con un profesional como emisor, el contrato es de retención: lo que no se queda el profesional se le retiene en la liquidación o la rendición.'

export function describeValidity(validFrom: string, validUntil: string | null): string {
  if (!validUntil) return `desde el ${formatIsoDate(validFrom)}, sin fecha hasta`
  return `del ${formatIsoDate(validFrom)} al ${formatIsoDate(validUntil)}`
}
